
export const CREDENTIALS = 'mcam-credentials'
